import React from "react";
import { Route, HashRouter } from "react-router-dom";

import AgendamentoRetirada from "./AgendamentoRetirada";
import Ajuda from "./Ajuda";
import AppState from "./model/AppState";
import Busca from "./Busca";
import Capa from "./Capa";
import Carrinho from "./Carrinho";
import Categoria from "./Categoria";
import CategoriaInterna from "./CategoriaInterna";
import Conteudo from "./Conteudo";
import DicasReceitasSalvas from "./DicasReceitasSalvas";
import FormaPagamento from "./FormaPagamento";
import Listas from "./Listas";
import ListaDetalhe from "./ListaDetalhe";
import ListasExcluir from "./ListasExcluir";
import Loja from "./Lojas";
import Home from "./Home";
import Menu from "./Menu";
import MenuLogado from "./MenuLogado";
import Produto from "./Produto";
import Inspirese from "./Inspirese";
import Ofertas from "./Ofertas";
import Login from "./Login";
import Cadastrese from "./Cadastrese";
import AjudaContato from "./AjudaContato";
import Pedidos from "./Pedidos";
import Esqueci from "./Esqueci";
import AjudaPaginas from "./AjudaPaginas";
import AjudaPagPolPriv from "./AjudaPaginaPoliticaPrivacidade";
import AjudaPagPolBQ from "./AjudaPaginaPoliticaBQ";
import AjudaPaginaRegulamentoProgamaBQ from "./AjudaPaginaRegulamentoProgamaBQ";
import AjudaPaginaTermosProgamaBQ from "./AjudaPaginaTermosProgamaBQ";
import AjudaPagBQ from "./AjudaPaginaBQ";
import NavegadorUtil from "./util/NavegadorUtil";
import AgendamentoDelivery from "./AgendamentoDelivery";
import ReactGA from 'react-ga';

import TelemetriaUtil from "./util/TelemetriaUtil";
import AlterarSenha from "./AlterarSenha";
 
type AppMainState = {
};

class App extends React.Component<any, AppMainState> {
  constructor(props: any) {
    super(props);
    AppState.setMockData(false);
    ReactGA.initialize('UA-37196844-5');
  }

  render(): any {
    return (
      <HashRouter basename={NavegadorUtil.getUrl("")}>
        <TelemetriaUtil instrumentationKey="7d02fc42-5f90-4713-afeb-4f7719bf786d">
          <Route exact path="/" component={Capa} />
          <Route path="/agendamento-delivery" component={AgendamentoDelivery} />
          <Route path="/agendamento-retirada" component={AgendamentoRetirada} />
          <Route exact path="/ajuda" component={Ajuda} />
          <Route exact path="/ajuda/contato" component={AjudaContato} />
          <Route exact path="/ajuda/cliente-bem-querer" component={AjudaPagBQ} />
          <Route exact path="/ajuda/paginas" component={AjudaPaginas} />
          <Route exact path="/ajuda/paginas/politica-privacidade-oba" component={AjudaPagPolPriv} />
          <Route exact path="/ajuda/paginas/politica-privacidade-bem-querer" component={AjudaPagPolBQ} />
          <Route exact path="/ajuda/paginas/termos-condicoes-bem-querer" component={AjudaPaginaTermosProgamaBQ} />
          <Route exact path="/ajuda/paginas/regulamento-programa-bem-querer" component={AjudaPaginaRegulamentoProgamaBQ} />
          <Route path="/busca" component={Busca} />
          <Route path="/cadastre-se" component={Cadastrese} />
          <Route path="/carrinho" component={Carrinho} />
          <Route path="/categoria" component={Categoria} />
          <Route path="/categoria-interna" component={CategoriaInterna} />
          <Route path="/conteudo" component={Conteudo} />
          <Route path="/dicas-receitas-salvas" component={DicasReceitasSalvas} />
          <Route path="/esqueci-minha-senha" component={Esqueci} />
          <Route path="/alterar-minha-senha" component={AlterarSenha} />
          <Route path="/forma-pagamento" component={FormaPagamento} />
          <Route path="/home" component={Home} />
          <Route path="/inspirese" component={Inspirese} />
          <Route path="/lista" component={ListaDetalhe} />
          <Route path="/listas" component={Listas} />
          <Route path="/listas-excluir" component={ListasExcluir} />
          <Route path="/login" component={Login} />
          <Route path="/lojas" component={Loja} />
          <Route path="/menu" component={Menu} />
          <Route path="/menu-logado" component={MenuLogado} />
          <Route path="/ofertas" component={Ofertas} />
          <Route path="/produto" component={Produto} />
          <Route path="/pedidos" component={Pedidos} />
          <Route path="/pedido" component={Pedidos} />
        </TelemetriaUtil>
      </HashRouter>
    );
  }
}

export default App;
